import React, {Component} from 'react';
import contact from "../../consumers/contact";
import PageTitle from "../../visitors/components/PageTitle";
import MessagesList from '../components/dashboard/MessagesList'

class Messages extends Component {

    constructor(props) {
        super(props);
        this.state = {
            messages: {}
        };
    }

    componentDidMount() {
        const {reference} = this.props;
        if (reference) {
            reference.once('value', this.handleList.bind(this));
            reference.on('child_removed', this.handleDelete.bind(this));
        }
    }

    handleList(snapshot) {
        if (snapshot.exists()) {
            const messages = {};
            snapshot.forEach(function (childSnapshot) {
                messages[childSnapshot.key] = childSnapshot.val();
            });

            this.setState({messages: messages});
        }
    }

    handleDelete(data) {
        const messages = Object.assign({}, this.state.messages);
        delete messages[data.key];
        this.setState({
            messages: messages
        });
    }

    delete(key) {
        this.props.reference.child(key).remove();
    }

    componentWillUnmount(){
        this.props.reference.off();
    }

    render() {
        return (
            <div className="container my-5">
                <PageTitle title="Mensajes"/>
                <section className="px-12">
                    <ul className="list-group">
                        <MessagesList
                            messages={this.state.messages}
                            callback={this.delete.bind(this)}
                        />
                    </ul>
                </section>
            </div>
        );
    }

}

export default contact(Messages);


// WEBPACK FOOTER //
// ./src/admin/subscribers/Messages.js